// extracted by mini-css-extract-plugin
module.exports = {"sodicFooterWrapper":"style_sodicFooterWrapper__RdQYw","sodicFooterInner":"style_sodicFooterInner__CeL4o"};